import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AppShell } from '@mantine/core';
import AppHeader from "../../components/app-header/app-header.component";
import AppFooter from "../../components/app-footer/app-footer.component";
import MobileDropdown from "../../components/mobile-dropdown/mobile-dropdown";
import { useContext } from "react";
import { UserContext } from "../../contexts/user.context";
import {IconFingerprint, IconBook,IconPresentation } from '@tabler/icons-react';

const links = [
  {
    text: 'Dashboard',
    to: '/dashboard',
    noUserTo: '/sign-up',
    type: 'internal',
    icon: <IconFingerprint stroke={1.5} size = {20}/>
  },
  {
    text: 'Demo',
    to: '/demo',
    noUserTo: '/sign-up',
    type: 'internal',
    icon: <IconPresentation stroke={1.5} size = {20}/>
  },
  {
    text: 'Docs',
    noUserTo: 'https://alias-docs.roundtable.ai',
    to: 'https://alias-docs.roundtable.ai',
    type: 'external',
    icon: <IconBook stroke={1.5} size = {20}/>
  },
];

const noLayoutFor = [
  // '/sign-in',
  // '/sign-up',
  // '/verify-email',
  // '/forgot-password',
];

const footerRoutes = [
  // '/',
  // '/showcase',
  // '/terms',
  // '/privacy',
];

const alwaysHeaderFor = [
  '/simulator-link',
  '/simulator',
  'showcase',
]

const headerFor = [
  '/dashboard',
  '/account',
  '/simulator',
  '/simulator-link',
  '/demo',
  '/showcase',
  // '/keystroke-history',
];

const containsPath = (array, target) => {
  return array.some(str => target.includes(str));
}

const Layout = () => {

  const [expandedMobileMenu, setExpandedMobileMenu] = useState(false);

  const { currentUser, setLogOutMessage } = useContext(UserContext);

  const location = useLocation();

  if (noLayoutFor.includes(location.pathname)) {
    return <AppShell padding={0}><Outlet /></AppShell>
  }

  const showHeader = containsPath(alwaysHeaderFor,location.pathname) || (currentUser && containsPath(headerFor,location.pathname));

  return (
    <AppShell
      padding={0}
      // fixed = {false}
      header={ showHeader && 
        <AppHeader
          expandedMobileMenu={expandedMobileMenu}
          setExpandedMobileMenu={setExpandedMobileMenu}
          textLinks={links}
          currentUser={currentUser}
        />
      }
      footer = {footerRoutes.includes(location.pathname) && <AppFooter /> }
    >
      {
        expandedMobileMenu
          ?
          <MobileDropdown
            setExpandedMobileMenu={setExpandedMobileMenu}
            currentUser={currentUser}
            textLinks={links}
            setLogOutMessage={setLogOutMessage}
          />
          :
          <Outlet />
      }
    </AppShell>
  )
}

export default Layout;